import { useMemo } from "react"

import find from "lodash-es/find"
import isEmpty from "lodash-es/isEmpty"

import { type TProductTypeQuery, useProductTypeQuery } from "@/3514/queries"
import { EProductTypeConfigTitle, type IProductTypeConfigModel } from "@/3514/types"

function useIsPostSessionModalEnabled(): boolean {
    const { data: productType, isSuccess: isProductTypeQuerySuccess }: TProductTypeQuery = useProductTypeQuery()

    return useMemo(
        (): boolean =>
            isProductTypeQuerySuccess
                ? isEmpty(productType.configs)
                    ? false
                    : find<IProductTypeConfigModel>(productType.configs, {
                          title: EProductTypeConfigTitle.ShowPostSessionPopup
                      }).isActive
                : false,
        [productType?.configs, isProductTypeQuerySuccess]
    )
}

export { useIsPostSessionModalEnabled }
